jQuery(document).ready(function() {
  launchCounter();
});

jQuery( window ).on('scroll', function() {
  launchCounter();
  if(jQuery('.aos-init:not(.aos-animate) .counter').length < 0){
    jQuery(window).off('scroll');
  }
});

function launchCounter() {
  jQuery('.aos-animate .counter').each(function() {
      var $this = jQuery(this),
          countTo = $this.attr('data-count');
      
        $({ countNum: $this.text()}).animate({
          countNum: countTo
        },      
        {      
          duration: 3000,
          easing:'linear',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
          }
      
        });  
    });
}
